import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type ProductsAttributesFlatTeamSettingGroupId =
  "products_attributes.attribute_definitions";

const groupOwner: SettingOwner = {
  kind: "teamSettings",
  product: "fulfillment",
};

const groupRisk: SettingRisk = {
  level: "low",
  reason:
    "Product-level settings including hazmat and product attribute definitions.",
};

export const ProductsAttributesFlatTeamSettingGroups = [
  {
    id: "products_attributes.attribute_definitions",
    title: "Attribute definitions",
    description:
      "Attribute definitions settings on the Products attributes page.",
    productArea: "general",
    access: directMerchantAccess(SettingsPermissions.SET_GENERAL_SETTINGS),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "attributes" },
    synonyms: [
      "attribute definitions",
      "products attributes",
      "product attributes",
      "product attribute definitions",
      "custom product attributes",
    ],
  },
] as const satisfies readonly SettingGroupDefinition<ProductsAttributesFlatTeamSettingGroupId>[];
